import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'ProcurementIcon',
  viewBox: '0 0 470 310',
  path: (
    <>
      {/* Stacked rounded blocks */}
      <rect x="60" y="208" width="220" height="36" rx="10" fill="#D4D4D4" stroke="currentColor" strokeWidth="2.5" />
      <rect x="60" y="226" width="220" height="36" rx="10" fill="#C8C8C8" stroke="currentColor" strokeWidth="2.5" />
      <rect x="60" y="244" width="220" height="36" rx="10" fill="#BCBCBC" stroke="currentColor" strokeWidth="2.5" />

      {/* Checkmark sitting on top of blocks */}
      <polygon
        points="80,168 120,210 134,210 220,94 202,94 124,190 90,150"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />

      {/* Generic coin */}
      <circle cx="230" cy="194" r="28" fill="white" stroke="currentColor" strokeWidth="2.5" />
      <circle cx="230" cy="194" r="18" fill="none" stroke="currentColor" strokeWidth="1.5" />

      {/* Smartphone body */}
      <rect x="278" y="62" width="110" height="200" rx="16" fill="white" stroke="currentColor" strokeWidth="2.5" />
      {/* Camera dots */}
      <circle cx="318" cy="82" r="3.5" fill="currentColor" />
      <circle cx="333" cy="82" r="3.5" fill="currentColor" />
      <circle cx="348" cy="82" r="3.5" fill="currentColor" />
      <circle cx="363" cy="82" r="2.5" fill="currentColor" />
      {/* Screen */}
      <rect x="290" y="97" width="86" height="122" rx="5" fill="none" stroke="currentColor" strokeWidth="1.8" />
      {/* Nav: back arrow */}
      <path
        d="M306,237 L314,231 L314,235 L322,235 L322,239 L314,239 L314,243 Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      {/* Nav: plus */}
      <line x1="340" y1="231" x2="340" y2="245" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      <line x1="333" y1="238" x2="347" y2="238" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      {/* Nav: line */}
      <line x1="362" y1="231" x2="362" y2="245" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />

      {/* Small circle */}
      <circle cx="290" cy="278" r="15" fill="white" stroke="currentColor" strokeWidth="2.5" />

      {/* Capsule */}
      <rect x="318" y="266" width="56" height="26" rx="13" fill="white" stroke="currentColor" strokeWidth="2.5" />
    </>
  ),
});
